import { flattenDeep, cloneDeep } from 'lodash-es'

export function fillConfig (config, formsConfig) {
  return config.map(item => {
    if (item.type === 'component' && item.id) {
      let form = cloneDeep(formsConfig.find(form => form.c_id === item.id))
      if (form) {
        let formConfig = form.c_config
        if (typeof formConfig === 'string') {
          /* eslint no-eval: "off" */
          formConfig = eval(formConfig)
        }
        let newConfig = fillConfig([formConfig], formsConfig)[0]

        if (item.display) {
          newConfig.display = item.display
        }
        // 增加可以拓展基础配置能力。增加 extend 字段，对相同 key 值做覆盖
        if (Array.isArray(item.extend)) {
          item.extend.forEach(conf => {
            let index = newConfig.items.findIndex(nc => nc.name === conf.name)
            if (index > -1) {
              let nc = Object.assign({}, newConfig.items[index], conf)
              newConfig.items[index] = nc
            }
          })
        }

        return newConfig
      }
    }

    if (Array.isArray(item.items)) {
      item.items = flattenDeep(fillConfig(item.items, formsConfig))

      return item
    }

    if (item.row) {
      item.row = flattenDeep(fillConfig(item.row, formsConfig))

      return item
    }

    if (item.columns) {
      item.columns = flattenDeep(fillConfig(item.columns, formsConfig))

      return item
    }

    return item
  })
}